import { useState, useEffect } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { LINE_URL, LOGO_URL } from "../constants";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Lock body scroll while mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  return (
    <header 
      data-testid="header-nav"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'header-blur border-b border-slate-100 py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-12 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Lakeze 人客多" className="h-10 md:h-12 w-auto" />
        </a>
        
        <nav className="hidden md:flex items-center gap-8">
          <a href="#services" className="text-[#0A2540] hover:text-[#FF6B00] transition-colors font-medium">服務內容</a>
          <a href="#pricing" className="text-[#0A2540] hover:text-[#FF6B00] transition-colors font-medium">方案價格</a>
          <a href="#cases" className="text-[#0A2540] hover:text-[#FF6B00] transition-colors font-medium">成功案例</a>
          <a href={LINE_URL} target="_blank" rel="noopener noreferrer" data-testid="header-cta-btn"
            className="bg-[#FF6B00] text-white hover:bg-[#E65A00] transition-all duration-300 font-bold rounded-full px-6 py-3 flex items-center gap-2 btn-lift">
            <MessageCircle className="w-5 h-5" />
            立即諮詢
          </a>
        </nav>

        <button className="md:hidden p-2 relative z-[60]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-testid="mobile-menu-btn" aria-label="開關選單">
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div
            className="md:hidden fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-40"
            onClick={() => setIsMobileMenuOpen(false)}
            data-testid="mobile-menu-backdrop"
          />
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-slate-100 shadow-xl px-6 py-5 space-y-1 z-50">
            <a href="#services" onClick={() => setIsMobileMenuOpen(false)} className="block text-[#0A2540] font-semibold py-3 border-b border-slate-100">服務內容</a>
            <a href="#pricing" onClick={() => setIsMobileMenuOpen(false)} className="block text-[#0A2540] font-semibold py-3 border-b border-slate-100">方案價格</a>
            <a href="#cases" onClick={() => setIsMobileMenuOpen(false)} className="block text-[#0A2540] font-semibold py-3 border-b border-slate-100">成功案例</a>
            <a href={LINE_URL} target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} data-testid="mobile-menu-cta"
              className="mt-3 bg-[#FF6B00] text-white font-bold rounded-full px-6 py-3.5 flex items-center justify-center gap-2 shadow-lg shadow-[#FF6B00]/30">
              <MessageCircle className="w-5 h-5" />
              立即諮詢
            </a>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
